<template>
    <layout-portal>
        <div class="dashboard-page p-0">
            <div class="row no-gutters">
                 <!-- order-xl-1 col-xl-9 -->
                <div class="order-2">
                    <dashboard-list
                        :showImage="false"
                        class="p-md-3"
                        listClass="col-sm-6 col-xl-4"/>
                </div>
                <!-- order-xl-2 col-xl-3 px-md-4 px-xl-3 -->
                <div class="order-1">
                    <!-- pt-sm-3 pt-lg-4 -->
                    <div class="card dashboard-help border-0 bg-transparent p-md-3">
                        <div class="card-body px-0 pt-0">
                            <h1 class="card-title content-title">
                                Dashboard
                            </h1>
                            <p class="card-text">Bem-vindo ao CityHub.pt. Através do dashboard pode aceder a diversas ferramentas de gestão do seu município.</p>
                            <p class="card-text">Fique rápidamente a par das suas notificações e mensagens. Aqui é onde tudo começa.</p>
                            <p class="card-text">Queremos ajudá-lo a criar um município ainda melhor.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout-portal>
</template>

<script>
    import mixin from '../mixin';
    import mixinTheme from '@/app/shared/mixins/theme';
    import DashboardList from '../elements/dashboard/DashboardList.vue';

    export default {
        mixins: [mixin, mixinTheme],
        components: {
            DashboardList
        },
    }
</script>
